var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "btnBox" },
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                attrs: { inline: true, model: _vm.searchForm, size: "mini" },
              },
              [
                _vm._l(_vm.combinedSearchItems, function (item, index) {
                  return _c("el-form-item", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-with-select",
                        staticStyle: { width: "200px" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "category-select",
                            staticStyle: { width: "80px" },
                            attrs: { clearable: "" },
                            on: {
                              change: function ($event) {
                                return _vm.handleSearchTypeChange(item, index)
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          },
                          _vm._l(item.options, function (option) {
                            return _c("el-option", {
                              key: option.value,
                              attrs: {
                                label: option.label,
                                value: option.value,
                              },
                            })
                          }),
                          1
                        ),
                        _c("el-input", {
                          staticStyle: { width: "110px" },
                          attrs: { placeholder: "请输入" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                          model: {
                            value: item.keyword,
                            callback: function ($$v) {
                              _vm.$set(item, "keyword", $$v)
                            },
                            expression: "item.keyword",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
                _c("el-form-item", { attrs: { prop: "categoryId" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-with-select",
                      staticStyle: { height: "40px" },
                    },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("商品类目"),
                      ]),
                      _c("el-cascader", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          options: _vm.categoryList,
                          props: { checkStrictly: true },
                          filterable: "",
                          clearable: "",
                        },
                        on: { change: _vm.onChangeCategory },
                        model: {
                          value: _vm.searchForm.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "categoryId", $$v)
                          },
                          expression: "searchForm.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", { attrs: { prop: "type" } }, [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("商品类型"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: "请选择",
                            filterable: "",
                            clearable: "",
                            multiple: "",
                            "collapse-tags": "",
                          },
                          model: {
                            value: _vm.searchForm.goodsTypes,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "goodsTypes", $$v)
                            },
                            expression: "searchForm.goodsTypes",
                          },
                        },
                        _vm._l(_vm.dictionaries.goods_type, function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", { attrs: { prop: "brandId" } }, [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("品牌"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: "请选择",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.brandId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "brandId", $$v)
                            },
                            expression: "searchForm.brandId",
                          },
                        },
                        _vm._l(_vm.brandList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", { attrs: { prop: "origin" } }, [
                  _c(
                    "div",
                    { staticClass: "input-with-select" },
                    [
                      _c("span", { staticClass: "prepend-text" }, [
                        _vm._v("商品来源"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: "请选择",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.platformId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "platformId", $$v)
                            },
                            expression: "searchForm.platformId",
                          },
                        },
                        _vm._l(_vm.platformList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  { staticClass: "form-buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c("div", { staticClass: "btn-list" }, [
          _c("div", { staticClass: "tab-buttons" }, [
            _c(
              "div",
              {
                staticClass: "tab-button",
                class: {
                  active: _vm.currentStatus === _vm.groupByStatus.total,
                },
                on: {
                  click: function ($event) {
                    return _vm.onChangeList(_vm.groupByStatus.total)
                  },
                },
              },
              [_vm._v(" 全部(" + _vm._s(_vm.countGroupByStatus.total) + ") ")]
            ),
            _c(
              "div",
              {
                staticClass: "tab-button",
                class: { active: _vm.currentStatus === _vm.groupByStatus.up },
                on: {
                  click: function ($event) {
                    return _vm.onChangeList(_vm.groupByStatus.up)
                  },
                },
              },
              [_vm._v(" 上架中(" + _vm._s(_vm.countGroupByStatus.up) + ") ")]
            ),
            _c(
              "div",
              {
                staticClass: "tab-button",
                class: { active: _vm.currentStatus === _vm.groupByStatus.down },
                on: {
                  click: function ($event) {
                    return _vm.onChangeList(_vm.groupByStatus.down)
                  },
                },
              },
              [_vm._v(" 已下架(" + _vm._s(_vm.countGroupByStatus.down) + ") ")]
            ),
          ]),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c(
                "el-button",
                { on: { click: _vm.handleBatchExternalSetting } },
                [_vm._v("批量对外设置")]
              ),
              _vm.parArray.indexOf("putOnCode") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          _vm.currentStatus === _vm.groupByStatus.up
                            ? true
                            : false,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.operationStatus("up")
                        },
                      },
                    },
                    [_vm._v("批量上架")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("putOffCode") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          _vm.currentStatus === _vm.groupByStatus.down
                            ? true
                            : false,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.operationStatus("down")
                        },
                      },
                    },
                    [_vm._v("批量下架")]
                  )
                : _vm._e(),
              _c("el-button", { on: { click: _vm.onImport } }, [
                _vm._v("批量导入"),
              ]),
              _c(
                "el-dropdown",
                {
                  staticStyle: { padding: "0 8px" },
                  attrs: { trigger: "hover" },
                  on: { command: _vm.handleBatchOperation },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { loading: _vm.GoodsExportLoading } },
                    [
                      _vm._v("导出商品 "),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "normal" } }, [
                        _vm._v("导出商品"),
                      ]),
                      _c("el-dropdown-item", { attrs: { command: "cost" } }, [
                        _vm._v("导出商品（成本）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.toOtherPages("goodsSyncCheck")
                    },
                  },
                },
                [_vm._v("九航同步商品核对")]
              ),
              _vm.parArray.indexOf("goodsadd_xzsp") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toOtherPages(
                            "goodsCategoryEdit",
                            "normal",
                            "add"
                          )
                        },
                      },
                    },
                    [_vm._v("新增商品")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("goodsadd_xzsp") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toOtherPages(
                            "goodsCategoryEdit",
                            "combination",
                            "add"
                          )
                        },
                      },
                    },
                    [_vm._v("新增组合商品")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: {
              padding: "0 10px",
              "background-color": "#fff",
              margin: "0 -10px",
            },
          },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: '"always"',
                },
              ],
              attrs: {
                border: "",
                column: _vm.columns,
                align: "center",
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50, 200],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
                orderStatistics: _vm.page.totalNum,
                statisticText: "当前列表统计总商品数",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
                refresh: _vm.fetchData,
                "selection-change": _vm.handleSelectionChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
            "custom-class":
              _vm.dialog.type === "modifyState" ? "modify-state" : "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "skuList"
            ? [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.dialog.list },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "sku", label: "SKU编码", width: "150" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "商品规格" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.secondGoodsSpecItemContent
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.firstGoodsSpecItemContent
                                        ) +
                                          " + " +
                                          _vm._s(
                                            scope.row.secondGoodsSpecItemContent
                                          )
                                      ),
                                    ])
                                  : scope.row.thirdGoodsSpecItemContent
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.firstGoodsSpecItemContent
                                        ) +
                                          " + " +
                                          _vm._s(
                                            scope.row.secondGoodsSpecItemContent
                                          ) +
                                          " + " +
                                          _vm._s(
                                            scope.row.thirdGoodsSpecItemContent
                                          )
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.firstGoodsSpecItemContent
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1979158954
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "marketPrice", label: "市场价" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "retailPrice", label: "零售价" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "stock", label: "库存" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCopySku(scope.row.sku)
                                      },
                                    },
                                  },
                                  [_vm._v("复制")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        465793388
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "modifyState"
            ? [
                _c("modify-state", {
                  attrs: { dialogInfo: _vm.dialog, list: _vm.giftListByGoodId },
                }),
                _c(
                  "div",
                  {
                    staticClass: "header-title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                    ]),
                    _c("label", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.dialog.title)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c("el-button", { on: { click: _vm.centerModifyState } }, [
                      _vm._v("取 消"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.submitModifyState },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "retailPrice" ||
          _vm.dialog.type === "store" ||
          _vm.dialog.type === "sellNum" ||
          _vm.dialog.type === "settlePrice"
            ? [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            plain: "",
                            type: _vm.isStatus == "1" ? "primary" : " ",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.isUpPlatform(1)
                            },
                          },
                        },
                        [_vm._v("已上架平台")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            plain: "",
                            type: _vm.isStatus == "0" ? "primary" : " ",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.isUpPlatform(0)
                            },
                          },
                        },
                        [_vm._v("待上架平台")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "dialog-search" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "searchForm",
                          staticClass: "search-form",
                          attrs: {
                            inline: true,
                            model: _vm.searchForm,
                            size: "small",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "平台名称", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入平台名称",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.platformName,
                                  callback: function ($$v) {
                                    _vm.platformName = $$v
                                  },
                                  expression: "platformName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "dialog-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.goodsPlatformPrice()
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.dialog.list,
                      "span-method": _vm.objectSpanMethod,
                      "header-cell-style": {
                        "text-align": "center",
                        background: "#F8F8F8",
                      },
                      "cell-style": { "text-align": "center" },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "平台名称", width: "150" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "skuName", label: "商品规格" },
                    }),
                    _vm.dialog.type === "settlePrice"
                      ? _c("el-table-column", {
                          attrs: { prop: "settlementPrice", label: "结算价" },
                        })
                      : _vm._e(),
                    _vm.dialog.type === "retailPrice"
                      ? _c("el-table-column", {
                          attrs: { prop: "retailPrice", label: "零售价" },
                        })
                      : _vm._e(),
                    _vm.dialog.type === "store"
                      ? _c("el-table-column", {
                          attrs: { prop: "store", label: "可用库存" },
                        })
                      : _vm._e(),
                    _vm.dialog.type === "sellNum"
                      ? _c("el-table-column", {
                          attrs: { prop: "sellNum", label: "销量" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialog-pagination" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": 1,
                        "page-sizes": [10, 20, 30, 40],
                        "page-size": 10,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.dialog.totalNum,
                      },
                      on: {
                        "size-change": _vm.handleSizeChangeDialog,
                        "current-change": _vm.handleCurrentChangeDialog,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.isShow,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          [
            _vm.title === "批量上架"
              ? _c("div", [_vm._v("选择上架平台")])
              : _c("div", [_vm._v("选择下架平台")]),
            _c(
              "div",
              { staticClass: "platform" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "el-checkbox-group",
                  {
                    on: { change: _vm.handleCheckedplatformChange },
                    model: {
                      value: _vm.dialog.platformId,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialog, "platformId", $$v)
                      },
                      expression: "dialog.platformId",
                    },
                  },
                  _vm._l(_vm.platformList1, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.platformId,
                        staticStyle: { width: "44%" },
                        attrs: { label: item.platformId },
                      },
                      [_vm._v(_vm._s(item.platformName))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "text-align": "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "info" },
                    on: {
                      click: function ($event) {
                        _vm.isShow = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitisUp()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品上架平台",
            visible: _vm.isPlatform,
            width: "592px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isPlatform = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
              _vm._l(_vm.goodsPlatformList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      "margin-right": "20px",
                      width: "auto",
                      height: "32px",
                      background: "#f0f3fd",
                      opacity: "1",
                      "border-radius": "4px",
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      "line-height": "32px",
                      color: "#333333",
                      "text-align": "center",
                      "padding-left": "8px",
                      "padding-right": "8px",
                    },
                  },
                  [_vm._v(" " + _vm._s(item.platformName) + " ")]
                )
              }),
              0
            ),
            _c("div", {
              staticStyle: {
                width: "592px",
                height: "0px",
                border: "1px solid #d9d9d9",
                opacity: "1",
                "margin-top": "30px",
                "margin-left": "-20px",
              },
            }),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "14px" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      background: "#4168e7",
                      opacity: "1",
                      "border-radius": "4px",
                    },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.isPlatform = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.singleTitle,
            visible: _vm.isSingle,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSingle = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "dialog-search" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm",
                      staticClass: "search-form",
                      attrs: {
                        inline: true,
                        model: _vm.searchForm,
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "平台名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入平台名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.platformName,
                              callback: function ($$v) {
                                _vm.platformName = $$v
                              },
                              expression: "platformName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "dialog-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.searchPlatform()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.goodsPlatformList,
                  "header-cell-style": { color: "#333333" },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "platformName", label: "平台名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(scope.row.platformName)),
                            scope.row.originFlag == true
                              ? _c("span", [_vm._v("(来源平台)")])
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "status", label: "上下架", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                value: scope.row.statusLabel,
                                "active-color": "#409EFF",
                                "inactive-color": "#909099",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.controlUp(scope.row, scope.$index)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("span", [_vm._v("上下架")]),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: "控制该商品全部SKU规格在平台的上下架",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                "font-size": "20px",
                                cursor: "pointer",
                                "margin-left": "6px",
                                "margin-top": "4px",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.submitSingle },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示信息",
            visible: _vm.isS,
            width: "643px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isS = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              {
                staticClass: "info",
                staticStyle: { "text-align": "left", "margin-left": "60px" },
              },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red", "font-size": "20px" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.msg))]),
              ]
            ),
            _vm.gL.length != 0
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      width: "468px",
                      background: "#F1F6FF",
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      "line-height": "22px",
                      color: "#333333",
                      "margin-left": "60px",
                      "margin-top": "15px",
                      padding: "12px 10px",
                    },
                  },
                  [
                    _vm._v(" 该商品已被"),
                    _vm.gL.length != 0
                      ? _c("span", { staticStyle: { color: "#2d7edf" } }, [
                          _vm._v("【"),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.gL, function (item, index) {
                      return _c(
                        "span",
                        { key: index, staticStyle: { color: "#4168E7" } },
                        [
                          index > 0
                            ? _c(
                                "span",
                                { staticStyle: { color: "#4168E7" } },
                                [_vm._v("， ")]
                              )
                            : _vm._e(),
                          _vm._v(_vm._s(item)),
                        ]
                      )
                    }),
                    _vm.gL.length != 0
                      ? _c("span", { staticStyle: { color: "#2d7edf" } }, [
                          _vm._v("】"),
                        ])
                      : _vm._e(),
                    _vm._v("关联，若确认下架，则所关联的商品都下架！ "),
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isS = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.isSsubmit()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量上架失败",
            visible: _vm.isE,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isE = $event
            },
          },
        },
        [
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.tableData2,
                  "header-cell-style": { color: "#333333" },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "index", label: "", width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(scope.$index + 1) + " "),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "platformName",
                    label: "上架平台",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "goodsName", label: "上架商品", width: "150" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "message", label: "失败原因" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "10px", "text-align": "right" } },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.page2,
                    "page-size": _vm.size2,
                    "page-sizes": _vm.pageSizes2,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total2,
                  },
                  on: {
                    "size-change": _vm.sizeChange2,
                    "current-change": _vm.currentChange2,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.isE = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量下架确认",
            visible: _vm.isQ,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isQ = $event
            },
          },
        },
        [
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.tableData3,
                  "header-cell-style": { color: "#333333" },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "index", label: "", width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(" " + _vm._s(scope.$index + 1) + " "),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "platformName",
                    label: "下架平台",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "goodsName", label: "下架商品", width: "150" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "message", label: "原因" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-top": "10px", "text-align": "right" } },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.page3,
                    "page-size": _vm.size3,
                    "page-sizes": _vm.pageSizes3,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total3,
                  },
                  on: {
                    "size-change": _vm.sizeChange3,
                    "current-change": _vm.currentChange3,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "info" },
                    on: {
                      click: function ($event) {
                        _vm.isQ = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.QS } },
                  [_vm._v("确认下架")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            center: "",
            title: "提示",
            visible: _vm.externalDialog.visible,
            width: "400px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.externalDialog, "visible", $event)
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticStyle: { "margin-left": "40px" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "10px",
                      "font-size": "16px",
                    },
                  },
                  [_vm._v("请选择所选商品是否对外")]
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "260px" },
                    attrs: { placeholder: "请选择" },
                    model: {
                      value: _vm.externalDialog.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.externalDialog, "value", $$v)
                      },
                      expression: "externalDialog.value",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "是", value: "1" } }),
                    _c("el-option", { attrs: { label: "否", value: "2" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.confirmExternalSetting()
                      },
                    },
                  },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "info" },
                    on: {
                      click: function ($event) {
                        _vm.externalDialog.visible = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入",
            visible: _vm.isImport,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isImport = $event
            },
          },
        },
        [
          [
            _c(
              "div",
              { staticClass: "popIn" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "tops",
                    staticClass: "upload-demo",
                    attrs: {
                      accept: ".doc,.docx,.xls,.xlsx,.csv",
                      drag: "",
                      action: "#",
                      multiple: false,
                      "http-request": _vm.fileImport,
                      limit: 1,
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(" 将文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "dialog-footer" }, [
              _c(
                "div",
                { on: { click: _vm.downloadTemplate } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "text", icon: "el-icon-download" } },
                    [_vm._v("导入模板下载")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function ($event) {
                          _vm.isImport = false
                        },
                      },
                    },
                    [_vm._v("取消 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "affirm",
                      attrs: { type: "primary" },
                      on: { click: _vm.submitImport },
                    },
                    [_vm._v("确定 ")]
                  ),
                ],
                1
              ),
            ]),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }